module.exports = __webpack_public_path__ + "img/IMG_20130404_124903.fb4c1636.jpg";